module.exports = __webpack_public_path__ + "img/1024.f0f6f032.png";